import { render, staticRenderFns } from "./ProductTokenList.vue?vue&type=template&id=c40aa092&scoped=true"
import script from "./ProductTokenList.vue?vue&type=script&lang=js"
export * from "./ProductTokenList.vue?vue&type=script&lang=js"
import style0 from "./ProductTokenList.vue?vue&type=style&index=0&id=c40aa092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40aa092",
  null
  
)

export default component.exports